import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { valByKeyWithDot } from '../../../../../helpers/value'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '../constant'

const initialState = {
  ids: [],
  byId: {},
  checked: {},
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
}

const slice = createSlice({
  name: 'dynamicReport/preferenceSetting/templates',
  initialState: initialState,
  reducers: {
    resetStoreTemplates(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeTemplates: (state, action) => {
      const data = action.payload

      state.ids = data.map((template) => {
        return template.id
      })

      state.byId = keyBy(data, 'id')
    },
    checkItem: (state, action) => {
      state.checked[action.payload] = true
    },
    uncheckItem: (state, action) => {
      delete state.checked[action.payload]
    },
    checkItems: (state, action) => {
      action.payload.forEach((id) => (state.checked[id] = true))
    },
    uncheckItems: (state, action) => {
      action.payload.forEach((id) => delete state.checked[id])
    },
    checkAllItem: (state) => {
      state.ids.forEach((id) => {
        state.checked[id] = true
      })
    },
    uncheckAllItem: (state) => {
      state.checked = {}
    },
    changePage: (state, action) => {
      state.page = action.payload
    },
    changePageSize: (state, action) => {
      state.pageSize = action.payload
    },
  },
})

export const selectIds = (state) => state[slice.name].ids

export const selectById = (state) => state[slice.name].byId

export const selectCell = (id, attr) => (state) =>
  valByKeyWithDot(state[slice.name].byId[id], attr)

export const selectChecked = (state) => state[slice.name].checked

export const selectCheckeditem = (id) => (state) =>
  state[slice.name].checked[id]

export const selectPage = (state) => state[slice.name].page

export const selectPageSize = (state) => state[slice.name].pageSize

export const {
  changeTemplates,
  checkItem,
  uncheckItem,
  checkItems,
  uncheckItems,
  checkAllItem,
  uncheckAllItem,
  changePage,
  changePageSize,
  resetStoreTemplates,
} = slice.actions

register(slice.name, slice.reducer)
